import { createFileRoute, Outlet, useLocation, useParams } from '@tanstack/react-router';
import { NoAccess } from '@/components/custom/no-access';
import { useMe } from '@/lib/me';

// Layout for /users/* — list + detail + edit nest under a common parent.
// Gates every child on `user.view`, EXCEPT viewing (not editing) one's own
// record. The detail page is also where the self-rating "My Skill" tab
// lives (users.$id.index.tsx), and GET /api/users/:id already lets a
// caller through for their own id regardless of user.view — a self-access
// bypass added specifically so an employee without user.view could reach
// their own profile (see UserService.getById). This layout used to
// contradict that: it blocked the self case before the page ever mounted,
// which is the bug this exception fixes. Edit is NOT exempted — it still
// needs user.view here, same as every other child, before user.edit (the
// separate, more sensitive authority) is checked at the edit route/backend.
export const Route = createFileRoute('/_authenticated/users')({
  component: UsersLayout,
});

function UsersLayout() {
  const { user: me, permissions, loading } = useMe();
  const { id } = useParams({ strict: false });
  const location = useLocation();
  const isOwnDetailView = id != null && me?.id === id && !location.pathname.endsWith('/edit');

  if (!loading && !permissions.has('user.view') && !isOwnDetailView) {
    return <NoAccess permission="user.view" resource="Employees" />;
  }
  return <Outlet />;
}
